module.exports = __webpack_public_path__ + "media/icons/link-mail_lv-e54025b6.png";